module.exports = "/images/modal-alert.svg?67cad4f139ffd75bbf3b84eee28eac5f";